import { fromNullable } from 'maybeasy';
import { MutableRefObject } from 'react';
import { MultiValue } from 'react-select';
import { normalizeValue } from '../../../../../../../../../../NormalizeValue';
import { FilterOption, FilterValue } from './Types';

export const handleSelectionChange =
  (
    onChange: (value: FilterOption) => void,
    setOptionSelectedState: (selectedValue: FilterOption) => void,
  ) =>
  (selectedOption: FilterOption | MultiValue<FilterOption> | null) => {
    const option = normalizeValue(selectedOption).getOrElseValue({
      value: '',
      label: '',
      participantCount: 0,
    });

    setOptionSelectedState(option);
    onChange(option);
  };

export const handleInputChange =
  (
    debouncer: MutableRefObject<NodeJS.Timeout | undefined>,
    setFilteringState: (filterBy: FilterValue) => void,
  ) =>
  (inputValue: string) => {
    fromNullable(debouncer.current).do(clearTimeout);
    debouncer.current = setTimeout(() => {
      setFilteringState(inputValue);
    }, 300);
  };
